var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiMessageImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 200,
    viewBox: "0 0 320 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    rx: 4,
    fill: "#EFF3F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.187 108C178.187 114.627 172.733 120 166.007 120H143V112H166.007C168.249 112 170.067 110.209 170.067 108C170.067 105.791 168.249 104 166.007 104H157.887V96H166.007C168.249 96 170.067 94.2091 170.067 92C170.067 89.7909 168.249 88 166.007 88H143V80H166.007C172.733 80 178.187 85.3726 178.187 92C178.187 95.0734 177.014 97.877 175.085 100C177.014 102.123 178.187 104.927 178.187 108Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143 88H162.76C158.563 83.1422 151.88 80 144.353 80C143.899 80 143.448 80.0114 143 80.034V88ZM166.898 103.998H159.238V95.998H166.898C167.2 97.2905 167.358 98.6282 167.358 99.998C167.358 101.368 167.2 102.706 166.898 103.998ZM143 112H162.76C158.563 116.858 151.88 120 144.353 120C143.899 120 143.448 119.989 143 119.966V112Z",
    fill: "#F7F8FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143 80C154.211 80 163.3 88.9543 163.3 100C163.3 111.046 154.211 120 143 120V112C149.727 112 155.18 106.627 155.18 100C155.18 93.3726 149.727 88 143 88V80Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiMessageImagePlaceholder);
export default __webpack_public_path__ + "static/media/hi-message-image-placeholder.09c7e5b768a8fecd9ce9bf4da3343cdd.svg";
export { ForwardRef as ReactComponent };